import { useEffect, useRef, useState, useCallback } from 'react';

export const useScrollToElement = (selector: string, offset = 100) => {
  const [showButton, setShowButton] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    const element = document.querySelector(selector);
    if (!element) return;

    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        // Show button if less than 10% of the element is visible
        setShowButton(entry.intersectionRatio < 0.1);
      },
      { threshold: Array.from({ length: 11 }, (_, i) => i / 10) },
    );

    observerRef.current.observe(element);

    return () => {
      observerRef.current?.disconnect();
    };
  }, [selector]);

  const scrollToElement = useCallback(() => {
    const element = document.querySelector(selector);
    if (element) {
      const top = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }, [selector, offset]);

  return { showButton, scrollToElement };
};
